import { Col, Row } from 'antd';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import styles from './overview.module.css';

interface LayoutProps {
  main: ReactNode;
  right: ReactNode;
}

const Wrapper = styled.div`
  padding: var(--layout-01);
  padding-left: var(--left-spacing);
`;

const Right = styled(Col)`
  overflow: hidden;
  padding-bottom: var(--spacing-03);
  background: var(--white-100);
  min-width: 320px !important;
  min-height: 1px;
  transition: top 200ms;
  box-shadow: var(--shadow-01);
`;

export const Layout: FC<LayoutProps> = ({ main, right }) => (
  <Wrapper>
    <Row align="top">
      <Col span={16} lg={14} className={styles.main}>
        {main}
      </Col>
      <Right span={8} lg={10}>
        {right}
      </Right>
    </Row>
  </Wrapper>
);
